import React from 'react';
import { FormField } from 'informed';
import { arrayOf, shape, string } from 'prop-types';
import { useIntl } from 'react-intl';
import { FormFieldset, FormLegend } from '@tesla/design-system-react';
import messages from './messages';
import { useTCLFormApi } from '../../../hooks';
import formStyle from '../../JobApplicationForm/style.module.scss';
import { getLegalCopyKey } from '../../../utils/common';

const LegalSection = ({ fields }) => {
  const intl = useIntl();
  const { formatMessage, locale } = intl;
  const formHelper = useTCLFormApi();

  const validateLegalAcknowledgment = (value) =>
    value !== true ? formatMessage(messages.AcknowledgmentRequiredMessage) : undefined;

  const legalCopyKey = getLegalCopyKey(formHelper.applicationType, locale);

  return (
    <>
      <FormFieldset className={formStyle.FormSection}>
        {fields.other.map((field) => (
          <div key={field} className={formStyle.FormFieldHalfWidth}>
            <FormField {...formHelper.field(field)} />
          </div>
        ))}
      </FormFieldset>

      <FormFieldset className={formStyle.FormSection}>
        <div className={formStyle.Intro}>
          <FormLegend text={formatMessage(messages.AcknowledgmentHeading)} variant="h5" />
          <p
            // eslint-disable-next-line react/no-danger
            dangerouslySetInnerHTML={{ __html: formatMessage(messages[legalCopyKey]) }}
          />
        </div>
        <FormField
          {...formHelper.field(fields.legalAcknowledgment)}
          validate={validateLegalAcknowledgment}
          required
        />
        <div className={`${formStyle.FormFieldHalfWidth}`}>
          <FormField
            {...formHelper.field(fields.legalAcknowledgmentName)}
            onKeyPress={(e) => {
              // Prevent form submissions on input enter.
              // @todo upgrade to informed-tds instead of react-context-form for a long-term solution.
              // eslint-disable-next-line no-unused-expressions
              e.key === 'Enter' && e.preventDefault();
            }}
            required
          />
        </div>
      </FormFieldset>
    </>
  );
};

LegalSection.propTypes = {
  fields: shape({
    other: arrayOf(string),
    legalAcknowledgment: string.isRequired,
    legalAcknowledgmentName: string.isRequired,
  }),
};

LegalSection.defaultProps = {
  fields: {
    other: [],
  },
};

export default LegalSection;
